<template>
  <div>
    <!-- VISTA CREAR INDIVIDUAL -->
    <div class="grid grid-cols-6 gap-6">
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="tipo_embargo" class="block text-sm font-medium text-gray-700">Tipo de Embargo <span style="color: red">(*)</span></label>
        <select id="tipo_embargo" :value="tipo_embargo" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          @change="(tipo_embargoNew) => {updateTipoEmbargo(tipo_embargoNew.target.value)}">
          <option value="" selected>Seleccione tipo de proceso...</option>
          <option value="RAMA JUDICIAL">Rama Judicial</option>
          <option value="COACTIVO">Cobro Coactivo</option>
        </select>
      </div>
      <div v-if="tipo_embargo =='RAMA JUDICIAL'" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="id_juzgado" class="block text-sm font-medium text-gray-700">Juzgado / Rama Judicial <span style="color: red">(*)</span></label>
        <select id="id_juzgado" :value="loadData.id_juzgado ? loadData.id_juzgado : selectedData.id_juzgado" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        @input="changeDataJuzgado($event.target.value)"
        @change="(nombre_juzgadoNew) => $emit('updateValues', {'id_juzgado': customUpdateValueData('id_juzgado', nombre_juzgadoNew.target.value), 'tipo_embargo': 'RAMA JUDICIAL' , 'id_entidad_cobro': '',})">
          <option value="" selected>Seleccione un Juzgado...</option>
          <option v-for="(juzgado, index) of collectionJuzgados" :key="'B' + index" :value="juzgado.id">
            {{juzgado.nombre_juzgado}}
          </option>
        </select>
      </div>
      <div v-else-if="tipo_embargo =='COACTIVO'" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="id_entidad_cobro" class="block text-sm font-medium text-gray-700" >Entidad Cobro Coactivo <span style="color: red">(*)</span></label>
        <select id="id_entidad_cobro" :value="loadData.id_entidad_cobro" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          @change="(nombre_entidadNew) => $emit('updateValues', {'id_entidad_cobro': customUpdateValueData('id_entidad_cobro', nombre_entidadNew.target.value),  'tipo_embargo': 'COACTIVO','id_juzgado': '',})">
          <option value="" selected>Seleccione una Entidad...</option>
          <option v-for="(entidad_cobro, index) of collectionEntidades" :key="'B' + index" :value="entidad_cobro.id">
            {{entidad_cobro.nombre_entidad}}
          </option>
        </select>
      </div>
      <div v-if="tipo_embargo =='RAMA JUDICIAL'" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="identificacion_juzgado" class="block text-sm font-medium text-gray-700">Identificación del Juzgado <span style="color: red">(*)</span></label>
        <input type="text"  id="identificacion_juzgado" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #e7e7e7"
          :value="identificacion_juzgado ? identificacion_juzgado : loadData.cuentaBancaria.identificacion_juzgado"
          disabled
        />
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="numero_oficio" class="block text-sm font-medium text-gray-700">Número de Oficio <span style="color: red">(*)</span></label>
        <input type="text" id="numero_oficio" :value="loadData.numero_oficio" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          @change="(numeroOficioNew)=>$emit('updateValues', {'numero_oficio': customUpdateValueData('numero_oficio', numeroOficioNew.target.value)})"/>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="fecha_oficio" class="block text-sm font-medium text-gray-700">Fecha de Oficio <span style="color: red">(*)</span></label>
        <input type="date" id="fecha_oficio" :value="loadData.fecha_oficio" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          @change="(fechaOficioNew)=>$emit('updateValues', {'fecha_oficio': customUpdateValueData('fecha_oficio', fechaOficioNew.target.value)})"
        />
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="numero_proceso" class="block text-sm font-medium text-gray-700">Numero de Proceso <span style="color: red">(*)</span></label>
        <span v-if="tipo_embargo =='RAMA JUDICIAL'" style="color: red; font-size: 13px">Porfavor diligencie los 23 digitos del Proceso (*)</span>
        <input :maxlength="tipo_embargo == 'RAMA JUDICIAL' ? 23 : 100" type="text" id="numero_proceso" :value="loadData.numero_proceso"
          class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          @change="(numeroProcesoNew) => $emit('updateValues', { 'numero_proceso': customUpdateValueData('numero_proceso', numeroProcesoNew.target.value) })"
        />
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="radicado" class="block text-sm font-medium text-gray-700" >Radicado Tesorería - Número <span style="color: red">(*)</span></label>
        <input type="text" id="radicado" :value="loadData.radicado" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          @change="(numeroRadicadoNew) => $emit('updateValues', { 'radicado': customUpdateValueData('radicado', numeroRadicadoNew.target.value), 'radicado_tesoreria_numero': customUpdateValueData('radicado_tesoreria_numero', numeroRadicadoNew.target.value) })"/>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="radicado_tesoreria_fecha" class="block text-sm font-medium text-gray-700" >Radicado Tesorería - Fecha</label>
        <input type="date" id="radicado_tesoreria_fecha" :value="loadData.radicado_tesoreria_fecha" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          @change="(fechaRadicadoNew) => $emit('updateValues', { 'radicado_tesoreria_fecha': customUpdateValueData('radicado_tesoreria_fecha', fechaRadicadoNew.target.value) })"/>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="numero_auto_resolucion" class="block text-sm font-medium text-gray-700">Numero Auto / Resolucion <span style="color: red">(*)</span></label>
        <input type="text" id="numero_auto_resolucion" :value="loadData.numero_auto_resolucion" 
          class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          @change="(numeroAutoResolucionNew) => $emit('updateValues', { 'numero_auto_resolucion': customUpdateValueData('numero_auto_resolucion', numeroAutoResolucionNew.target.value) })"
        />
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="titulo_deposito" class="block text-sm font-medium text-gray-700">Número Título / Deposito <span style="color: red">(*)</span></label>
        <input type="text" id="titulo_deposito" :value="loadData.titulo_deposito" 
          class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          @change="(tituloDepositoNew) => $emit('updateValues', { 'titulo_deposito': customUpdateValueData('titulo_deposito', tituloDepositoNew.target.value) })"
        />
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="tipo_identificacion_demandante" class="block text-sm font-medium text-gray-700">Tipo de Documento Demandante <span style="color: red">(*)</span></label>
        <select id="tipo_identificacion_demandante" :value="loadData.tipo_identificacion_demandante ? loadData.tipo_identificacion_demandante : loadData.demandante.id_tipo_identificacion"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          @input="{updateSecondName($event.target.value); 
                  updatePersona({tipo : $event.target.value, documento : loadData.identificacion_demandante ? loadData.identificacion_demandante : loadData.demandante.identificacion})
                  }"
          @change="(tipo_identificacion_demandanteNew) => $emit('updateValues', { 'tipo_identificacion_demandante': customUpdateValueData('tipo_identificacion_demandante', tipo_identificacion_demandanteNew.target.value) })">
          <option value="" selected>Seleccione un tipo...</option>
          <option v-for="(tipoDoc, index) of collectionTipoDoc" :key="'B' + index" :value="tipoDoc.id">
            {{tipoDoc.nombre_tipo_identificacion}}
          </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="identificacion_demandante" class="block text-sm font-medium text-gray-700">Identificación Demandante <span style="color: red">(*)</span></label>
        <input type="text" id="identificacion_demandante" :value="loadData.identificacion_demandante ? loadData.identificacion_demandante : inputs_nombres.identificacion"
          class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          @input="updatePersona({tipo: loadData.tipo_identificacion_demandante ? loadData.tipo_identificacion_demandante : loadData.demandante.id_tipo_identificacion, documento : $event.target.value })"
          @change="(identificacionDemandanteNew) => $emit('updateValues', { 'identificacion_demandante': customUpdateValueData('identificacion_demandante', identificacionDemandanteNew.target.value)})"/>
      </div>
      <div v-if="loadData?.demandante?.tipoDocumento?.nombre_tipo_identificacion == 'NIT' || loadData.tipo_identificacion_demandante == 6" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="primer_nombre_demandante" class="block text-sm font-medium text-gray-700">Nombre Demandante <span style="color: red">(*)</span></label>
        <input type="text" id="primer_nombre_demandante" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" :style="{backgroundColor: !valida_disabled ? '#e7e7e7' : ''}"
          :value="loadData.primer_nombre_demandante ? loadData.primer_nombre_demandante : inputs_nombres.primer_nombre"
          :disabled="!valida_disabled"
          @change="(primerNombreDemandanteNew) => $emit('updateValues', { 'primer_nombre_demandante': customUpdateValueData('primer_nombre_demandante', primerNombreDemandanteNew.target.value) })"/>
      </div>
      <div v-else class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="primer_nombre_demandante" class="block text-sm font-medium text-gray-700">Primer Nombre Demandante <span style="color: red">(*)</span></label>
        <input type="text" id="primer_nombre_demandante" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" :style="{backgroundColor: !valida_disabled ? '#e7e7e7' : ''}"
          :value="loadData.primer_nombre_demandante ? loadData.primer_nombre_demandante : inputs_nombres.primer_nombre"
          :disabled="!valida_disabled"
          @change="(primerNombreDemandanteNew) => $emit('updateValues', { 'primer_nombre_demandante': customUpdateValueData('primer_nombre_demandante', primerNombreDemandanteNew.target.value) })"/>
      </div>
      <div v-if="valida_nombre && loadData.tipo_identificacion_demandante != 6" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="segundo_nombre_demandante" class="block text-sm font-medium text-gray-700">Segundo Nombre Demandante </label>
        <input type="text" id="segundo_nombre_demandante" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" :style="{backgroundColor: !valida_disabled ? '#e7e7e7' : ''}"
          :value="loadData.segundo_nombre_demandante ? loadData.segundo_nombre_demandante : inputs_nombres.segundo_nombre"  
          :disabled="!valida_disabled"
          @change="(segundoNombreDemandanteNew) => $emit('updateValues', { 'segundo_nombre_demandante': customUpdateValueData('segundo_nombre_demandante', segundoNombreDemandanteNew.target.value) })"/>
      </div>
      <div v-if="valida_nombre && loadData.tipo_identificacion_demandante != 6" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="primer_apellido_demandante" class="block text-sm font-medium text-gray-700">Primer Apellido Demandante </label>
        <input type="text" id="primer_apellido_demandante" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" :style="{backgroundColor: !valida_disabled ? '#e7e7e7' : ''}"
          :value="loadData.primer_apellido_demandante ? loadData.primer_apellido_demandante : inputs_nombres.primer_apellido"
          :disabled="!valida_disabled"
          @change="(primerApellidoDemandanteNew) => $emit('updateValues', { 'primer_apellido_demandante': customUpdateValueData('primer_apellido_demandante', primerApellidoDemandanteNew.target.value) })"/>
      </div>
      <div v-if="valida_nombre && loadData.tipo_identificacion_demandante != 6" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="segundo_apellido_demandante" class="block text-sm font-medium text-gray-700">Segundo Apellido Demandante </label>
        <input type="text" id="segundo_apellido_demandante" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" :style="{backgroundColor: !valida_disabled ? '#e7e7e7' : ''}"
          :value="loadData.segundo_apellido_demandante ? loadData.segundo_apellido_demandante : inputs_nombres.segundo_apellido"
          :disabled="!valida_disabled"
          @change="(segundoApellidoDemandanteNew) => $emit('updateValues', { 'segundo_apellido_demandante': customUpdateValueData('segundo_apellido_demandante', segundoApellidoDemandanteNew.target.value) })" />
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="observaciones" class="block text-sm font-medium text-gray-700">Observaciones / Notas</label>
        <input type="text" id="observaciones" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          :value="loadData.observaciones"
          @change="(observacionesNew) => $emit('updateValues', { 'observaciones': customUpdateValueData('observaciones', observacionesNew.target.value) })" />
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="valor" class="block text-sm font-medium text-gray-700" >Valor de la Medida <span style="color: red">(*)</span></label>
        <input type="text" id="valor" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          :value="formattedValue || loadData.valor"
          @input="updateValue($event.target.value)"
          @change="(valorNew) => $emit('updateValues', { 'valor': customUpdateValueData('valor', valorNew.target.value) })"/>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="numero_egreso" class="block text-sm font-medium text-gray-700" >Número de Egreso <span style="color: red">(*)</span></label>
        <input type="text" id="numero_egreso" :value="loadData.numero_egreso" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          @change="(numeroEgresoNew) => $emit('updateValues', { 'numero_egreso': customUpdateValueData('numero_egreso', numeroEgresoNew.target.value) })"/>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="fecha_egreso" class="block text-sm font-medium text-gray-700">Fecha de Egreso <span style="color: red">(*)</span></label>
        <input type="date" id="fecha_egreso" :value="loadData.fecha_egreso" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          @change="(fechaEgresoNew)=>$emit('updateValues', {'fecha_egreso': customUpdateValueData('fecha_egreso', fechaEgresoNew.target.value)})"
        />
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="banco_id" class="block text-sm font-medium text-gray-700">Nombre del Banco <span style="color: red">(*)</span></label>
        <select id="banco_id" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          :value="loadData.cuentaBancaria && !id_banco ? loadData.cuentaBancaria.banco.id : id_banco"
          @change="(newIdBanco) => { id_banco = newIdBanco.target.value; loadCuentas(id_banco); }">
          <option value="" selected>Seleccione un banco...</option>
          <option v-for="(banco, index) of collectionBancos" :key="'B' + index" :value="banco.id">
            {{ banco.nombre_banco }}
          </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="id_cuenta_bancaria" class="block text-sm font-medium text-gray-700">Cuenta Bancaria <span style="color: red">(*)</span></label>
        <select id="id_cuenta_bancaria" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          :value="loadData.id_cuenta_bancaria"        
          @input="changeDataCuenta($event.target.value)"
          @change="(valorNew) => $emit('updateValues', { 'id_cuenta_bancaria': customUpdateValueData('id_cuenta_bancaria',valorNew.target.value) })">
          <option value="" selected>Seleccione una cuenta...</option>
          <option v-for="(cuenta, index) of collectionCuentas" :key="'B' + index" :value="cuenta.id">
            {{ cuenta.cuenta_bancaria }}
          </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="tipo_cuenta" class="block text-sm font-medium text-gray-700">Tipo de Cuenta</label>
        <input type="text"  id="tipo_cuenta" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #e7e7e7"
          :value="tipo_cuenta ? tipo_cuenta : loadData.cuentaBancaria.tipo_cuenta"
          disabled
        />
      </div>
      <div v-show="id_macro_fuente || view === 'actualizar'" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="macro_fuente" class="block text-sm font-medium text-gray-700">Macro Fuente<span :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
        <select id="macro_fuente" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          :value="id_macro_fuente ? id_macro_fuente: (selectedData?.cuentaBancaria?.cuentasFuentesMacro?.id_macro_fuente || '')" 
          @change="(newMacroFuenteId) => {id_macro_fuente = newMacroFuenteId.target.value;}" disabled>
          <option value="" selected>Seleccione una Macro Fuente...</option>
          <option v-for="(macroFuente, index) of collectionMacroFuente" :key="'B' + index" :value="macroFuente.id">
          {{ macroFuente.nombre }}
          </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="nombre_cuenta" class="block text-sm font-medium text-gray-700">Nombre de Cuenta / Fuente</label>
        <input type="text" id="nombre_cuenta" :value="nombre_cuenta ? nombre_cuenta : selectedData.cuentaBancaria.nombre_cuenta" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #e7e7e7"
          disabled
        />
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="fechaJuridica" class="block text-sm font-medium text-gray-700">Fecha Oficio Juridica </label>
        <input type="date" id="fecha_oficio_juridica" :value="loadData.fecha_oficio_juridica" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          @change="(fechaJuridicaNew)=>$emit('updateValues', {'fecha_oficio_juridica': customUpdateValueData('fecha_oficio_juridica', fechaJuridicaNew.target.value)})"
        />
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="oficio_juridica" class="block text-sm font-medium text-gray-700">Oficio Juridica / Ordenador Gasto </label>
        <input type="text" id="oficio_juridica" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          :value="loadData.oficio_juridica"
          @change="(oficioJuridicaNew) => $emit('updateValues', { 'oficio_juridica': customUpdateValueData('oficio_juridica', oficioJuridicaNew.target.value) })" />
      </div>
    </div>
  </div>
</template>

<script>
  import { computed, ref } from "vue";
  import { separateNumberByCommaInput, useAPIRest } from "@/common/constants";
  import Swal from "sweetalert2";

  export default {
    name: "EmbargosGobernacionCrearActualizarComponent",
    props: ["view","loadData","selectedData","customUpdateValueData","collectionEntidades","collectionTipoDoc","collectionJuzgados","collectionTipoPersona","collectionBancos","collectionMacroFuente","authToken"],
    emits: ["updateValues"],

    async setup(props, { emit }) {
      const valor = ref("");
      const collectionCuentas = ref();
      const id_banco = ref();
      const id_macro_fuente = ref();
      const nombre_cuenta = ref("");
      const tipo_cuenta = ref("");
      const valida_disabled = ref(props.view == 'actualizar' ? false : true);
      const tipo_embargo = ref(props.loadData.tipo_embargo);
      const valida_nombre = ref(props.loadData?.demandante?.tipoDocumento?.nombre_tipo_identificacion != 'NIT' ? true : false);
      const inputs_nombres = ref(props.loadData?.demandante ? props.loadData?.demandante : false);
      const identificacion_juzgado = ref('');
  
      if (props.loadData?.demandante) {
        emit("updateValues", {'tipo_identificacion_demandante' : props.loadData.demandante.id_tipo_identificacion});
      }

      const loadCuentas = async (id_banco) => {
        if (id_banco != "") {
          await useAPIRest(process.env.VUE_APP_NEST_CUENTABANCARIA_FINDINCUENTAFUENTE.replace(":id",id_banco),"GET",props.authToken,undefined,undefined,"application/json")
          .then(async (res) => {
            if (res.length > 0) {
              collectionCuentas.value = res;
            }else{
              Swal.fire({
                icon: 'warning',
                title: 'Atención!',
                text: 'Este banco no posee cuentas asociadas para embargos'
              });

              collectionCuentas.value = [];
              nombre_cuenta.value = '';
              tipo_cuenta.value = '';
              id_macro_fuente.value = '';
              emit('updateValues', { 'id_cuenta_bancaria': props.customUpdateValueData('id_cuenta_bancaria', '') })
            }
          });

        } else {
          collectionCuentas.value = [];
          emit('updateValues', { 'id_cuenta_bancaria': props.customUpdateValueData('id_cuenta_bancaria', '') })
        }
      };

      if (props.loadData.cuentaBancaria) {
        await loadCuentas(props.loadData.cuentaBancaria.banco.id);
      }

      const changeDataCuenta = async (newData) => {
        if (newData != "") {
          await useAPIRest(process.env.VUE_APP_NEST_CUENTABANCARIA_FINDONE.replace(":id",newData),"GET",props.authToken,undefined,undefined,"application/json")
            .then((res) => {
            nombre_cuenta.value = res.nombre_cuenta;
            tipo_cuenta.value = res.tipo_cuenta;
          });
          await useAPIRest(process.env.VUE_APP_NEST_CUENTAFUENTEMACRO_FINDONE.replace(":id",newData),"GET",props.authToken,undefined,undefined,"application/json")
          .then((res) => {
            id_macro_fuente.value = res.id_macro_fuente;
          });
        } else {
          id_macro_fuente.value = "";
        }
      };

      const changeDataJuzgado = async (dataJuzgado) => {
        if (dataJuzgado != '') {
          await useAPIRest(process.env.VUE_APP_NEST_JUZGADO_FINDONE.replace(":id",dataJuzgado),"GET", props.authToken,undefined,undefined,"application/json")
          .then((res) => {
              identificacion_juzgado.value = res.identificacion_juzgado;
          })
        }
      }

      if (props.loadData.id_juzgado) {
        await changeDataJuzgado(props.loadData.id_juzgado);
      }
      
      const formattedValue = computed(() => {
        if (valor.value !== "") {
          return separateNumberByCommaInput(valor.value);
        } else if (props.loadData.valor) {
          return separateNumberByCommaInput(props.loadData.valor);
        } else {
          return separateNumberByCommaInput(props.loadData.valor_inicial != undefined ? props.loadData.valor_inicial : '' );
        }
      });

      const updateValue = (newValue) => {
        valor.value = newValue;
        emit("updateValues", { valor: newValue });
      };

      const updateTipoEmbargo = async (tipo) => {
        tipo_embargo.value = tipo;
        if (props.view == "actualizar") {
          emit("updateValues", {tipo_embargo: props.customUpdateValueData("tipo_embargo",tipo_embargo),id_juzgado: "",id_entidad_cobro: ""});
        }
      };
      
      const updatePersona = async (val) => {
        const clearInputs = (document = null) => {
          valida_disabled.value = true;

          emit('updateValues', { 
              'identificacion_demandante'  : document ? document : '',
              'primer_nombre_demandante'   : '',
              'segundo_nombre_demandante'  : '',
              'primer_apellido_demandante' : '',
              'segundo_apellido_demandante': '',               
            });
            
            if (inputs_nombres.value != false) {
              inputs_nombres.value.identificacion   = '';
              inputs_nombres.value.primer_nombre    = '';
              inputs_nombres.value.segundo_nombre   = '';
              inputs_nombres.value.primer_apellido  = '';
              inputs_nombres.value.segundo_apellido = '';
            }
        }

        if (val.documento) {
          await useAPIRest(process.env.VUE_APP_NEST_PERSONA_FINDBYDOC.replace(':type', val.tipo).replace(":id", val.documento),"GET", props.authToken, undefined, undefined , "application/json")
          .then((res) => {
            if (res.statusCode == 200) {
              valida_disabled.value = false;
              emit("updateValues", {
                'identificacion_demandante'   : res.identificacion, 
                'primer_nombre_demandante'    : res.primer_nombre,
                'segundo_nombre_demandante'   : res.segundo_nombre,
                'primer_apellido_demandante'  : res.primer_apellido,
                'segundo_apellido_demandante' : res.segundo_apellido
              });
              
            } else if (res.statusCode == 400) {
              valida_disabled.value = true;
              clearInputs(val.documento);
            }
          })
        }else{
          clearInputs();
        }
      }

      const updateSecondName = async (value) => {
         emit('updateValues', { 'tipo_identificacion_demandante'  : props.customUpdateValueData('tipo_identificacion_demandante', value) })
        if (value == 6) {
          valida_nombre.value = false;
        }else{
          valida_nombre.value = true;
        }
      }

      return {
        loadCuentas,
        collectionCuentas,
        id_banco,
        id_macro_fuente,
        changeDataCuenta,
        nombre_cuenta,
        tipo_cuenta,
        formattedValue,
        updateValue,
        tipo_embargo,
        updateTipoEmbargo,
        updatePersona,
        valida_nombre,
        updateSecondName,
        valida_disabled,
        inputs_nombres,
        changeDataJuzgado,
        identificacion_juzgado
      };
    },
  };
</script>

<style>
  .bgDisabled {
    background-color: silver;
  }
</style>
